module.exports = __webpack_public_path__ + "img/kistimldms_02.e3c4e5f5.png";